import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region src/components/listMenu/ListMenuHeader.tsx
var n = ({ group: n, badge: r, badgeType: i = "muted", groupNavItem: a, className: o = "" }) => !n && !a ? null : /* @__PURE__ */ t("li", {
	className: "ListMenuHeader",
	children: [a || /* @__PURE__ */ e("span", {
		className: o,
		children: n
	}), r && /* @__PURE__ */ e("span", {
		className: `badge badge-${i}`,
		children: r
	})]
});
//#endregion
export { n as default };

//# sourceMappingURL=ListMenuHeader.js.map